export default {
    information: {
        altSubTitle:
            'こちらに入力された連絡先は、あなたが取引先に送る書類に表示されます。 この設定は後からいつでも変更可能です。',
        altTitle: '連絡先を追加します。',
        subtitle:
            '入力された住所は、MakeLeapsの利用登録および請求書発行時に書類に表示する連絡先として使用されます。',
        title: '会社の住所を設定しましょう',
    },
    pageForm: {
        title: '会社もしくは事業の連絡先住所',
    },
};
